if (!customElements.get('cc-bundle-offer')) {
  class CcBundleOffer extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.hasOptions = this.dataset.hasOptions === 'true';
      this.defaultVariantId = this.dataset.defaultVariantId;
      this.variants = [];
      const variantsJson = this.querySelector('[data-cc-variants]');
      if (variantsJson) {
        try {
          this.variants = JSON.parse(variantsJson.textContent);
        } catch (e) {
          this.variants = [];
        }
      }

      this.radios = Array.from(this.querySelectorAll('.cc-bundle__radio'));
      this.radios.forEach((radio) => {
        radio.addEventListener('change', () => this.onTierChange(radio));
      });

      this.querySelectorAll('.cc-bundle__select').forEach((select) => {
        select.addEventListener('change', () => this.onPieceChange(select));
      });
      // Klick auf Dropdown/Slot darf die Staffel-Auswahl (label) nicht mit auslösen
      this.querySelectorAll('.cc-bundle__pieces, .cc-bundle__slots').forEach((pieces) => {
        pieces.addEventListener('click', (e) => e.stopPropagation());
      });

      // Produkt-Auswahl (Bücher/Karten): EINE geteilte Auswahl-Liste über alle
      // Staffeln. Hauptprodukt ist fix, Zusatz-Produkte kommen per Modal dazu
      // und lassen sich per ✕ entfernen. Beim Staffelwechsel bleibt die
      // Auswahl erhalten (wie Kaching).
      this._modal = this.querySelector('[data-cc-modal]');
      this._chosen = [];
      try {
        this._offs = JSON.parse(this.dataset.offs || '[]') || [];
      } catch (e) {
        this._offs = [];
      }
      if (this._modal) {
        this.querySelectorAll('[data-slot-choose]').forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.openModal();
          });
        });
        this._modal.querySelectorAll('[data-cc-modal-close]').forEach((el) => {
          el.addEventListener('click', () => this.closeModal());
        });
        this._modal.querySelectorAll('[data-cc-modal-pick]').forEach((btn) => {
          btn.addEventListener('click', () => {
            if (this._chosen.length < this.slotsNeeded()) {
              this._chosen.push({ id: btn.dataset.variantId, title: btn.dataset.title, img: btn.dataset.img });
            }
            this.renderSlots();
            this.closeModal();
          });
        });
        // Modal an den Seiten-Body hängen, damit kein Theme-Element
        // (Stacking-Context) die Abdunklung überdecken kann.
        document.body.appendChild(this._modal);
        this.renderSlots();
        this.updateModalPrices();
      }

      this.querySelectorAll('[data-piece]').forEach((piece) => this.updatePieceImage(piece));

      // Kauf-Formular der Section abfangen: statt 1 Variante legen wir
      // die Stückzahl der gewählten Staffel als echte Artikel in den Warenkorb.
      this.onDocSubmit = (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        // Wichtig: getAttribute statt form.id — das Feld name="id" (Varianten-ID)
        // überschattet die id-Eigenschaft des Formulars.
        if (form.getAttribute('id') !== 'product-form-' + this.sectionId) return;
        event.preventDefault();
        event.stopPropagation();
        this.addToCart(form);
      };
      document.addEventListener('submit', this.onDocSubmit, true);

      this.initCountdown();
    }

    disconnectedCallback() {
      if (this._timer) clearInterval(this._timer);
      if (this.onDocSubmit) document.removeEventListener('submit', this.onDocSubmit, true);
      if (this._modal) this._modal.remove();
      document.body.style.overflow = '';
    }

    onTierChange(radio) {
      this.querySelectorAll('.cc-bundle__tier').forEach((tier) => tier.classList.remove('is-selected'));
      radio.closest('.cc-bundle__tier').classList.add('is-selected');
      this.renderSlots();
      this.updateModalPrices();
    }

    selectedTierInfo() {
      const checked = this.querySelector('.cc-bundle__radio:checked');
      if (!checked) return { qty: 1, index: 1 };
      return { qty: parseInt(checked.dataset.qty, 10) || 1, index: parseInt(checked.value, 10) || 1 };
    }

    slotsNeeded() {
      return Math.max(0, this.selectedTierInfo().qty - 1);
    }

    openModal(missing) {
      if (!this._modal) return;
      this.updateModalPrices();
      const note = this._modal.querySelector('[data-cc-modal-note]');
      if (note) {
        if (missing > 0) {
          note.textContent =
            missing === 1
              ? 'Bitte wähle noch 1 weiteres Produkt aus, um fortzufahren.'
              : 'Bitte wähle noch ' + missing + ' weitere Produkte aus, um fortzufahren.';
          note.hidden = false;
        } else {
          note.hidden = true;
        }
      }
      this._modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    // Zeichnet die gewählten Zusatz-Produkte in jede Staffel-Karte und
    // blendet die Plus/Auswählen-Zeile aus, sobald alle Plätze belegt sind.
    renderSlots() {
      this.querySelectorAll('[data-slots]').forEach((box) => {
        const need = Math.max(0, (parseInt(box.dataset.qty, 10) || 1) - 1);
        box.querySelectorAll('[data-chosen-row]').forEach((r) => r.remove());
        const addRow = box.querySelector('[data-slot-add]');
        this._chosen.slice(0, need).forEach((c, i) => {
          const row = document.createElement('span');
          row.className = 'cc-bundle__slot';
          row.setAttribute('data-chosen-row', '');
          const img = document.createElement('img');
          img.className = 'cc-bundle__slot-img';
          img.src = c.img;
          img.alt = '';
          img.width = 52;
          img.height = 52;
          const t = document.createElement('span');
          t.className = 'cc-bundle__slot-title';
          t.textContent = c.title;
          const x = document.createElement('button');
          x.type = 'button';
          x.className = 'cc-bundle__slot-x';
          x.setAttribute('aria-label', 'Entfernen');
          x.textContent = '✕';
          x.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            this._chosen.splice(i, 1);
            this.renderSlots();
          });
          row.append(img, t, x);
          box.insertBefore(row, addRow);
        });
        if (addRow) addRow.style.display = this._chosen.length >= need ? 'none' : '';
      });
    }

    // Modal zeigt die Stückpreise der aktuell gewählten Staffel (Preis − Rabatt/Stück).
    updateModalPrices() {
      if (!this._modal) return;
      const off = (parseFloat(this._offs[this.selectedTierInfo().index - 1]) || 0) * 100;
      this._modal.querySelectorAll('[data-cc-modal-price]').forEach((el) => {
        const base = parseInt(el.dataset.base, 10);
        if (!base) return;
        const cents = Math.max(0, Math.round(base - off));
        el.textContent = (cents / 100).toFixed(2).replace('.', ',') + '€';
      });
    }

    onPieceChange(select) {
      this.updatePieceImage(select.closest('[data-piece]'));
    }

    findVariantForPiece(piece) {
      const selects = Array.from(piece.querySelectorAll('.cc-bundle__select'));
      const chosen = selects.map((s) => s.value);
      return this.variants.find((v) =>
        chosen.every((value, idx) => v['option' + (idx + 1)] === value)
      );
    }

    updatePieceImage(piece) {
      if (!piece) return;
      const variant = this.findVariantForPiece(piece);
      const img = piece.querySelector('[data-piece-img]');
      if (variant && variant.featured_image && variant.featured_image.src && img) {
        img.src = variant.featured_image.src + (variant.featured_image.src.includes('?') ? '&' : '?') + 'width=96';
        // Nur das Bild zu tauschen wuerde den Alt-Text der vorherigen Variante stehen lassen.
        if (variant.title) img.alt = variant.title;
      }
    }

    collectItems() {
      const checked = this.querySelector('.cc-bundle__radio:checked');
      if (!checked) return null;
      const qty = parseInt(checked.dataset.qty, 10) || 1;
      const counts = new Map();

      const tier = checked.closest('.cc-bundle__tier');
      const slotsBox = tier.querySelector('[data-slots]');

      if (this.hasOptions) {
        const pieces = Array.from(tier.querySelectorAll('[data-piece]'));
        for (const piece of pieces) {
          const variant = this.findVariantForPiece(piece);
          if (!variant) return null;
          counts.set(variant.id, (counts.get(variant.id) || 0) + 1);
        }
      } else if (slotsBox) {
        // Bücher/Karten: Hauptprodukt 1x + gewählte Zusatz-Produkte.
        // Fehlen noch Auswahlen, wird das Auswahl-Fenster geöffnet.
        const need = Math.max(0, qty - 1);
        if (this._chosen.length < need) {
          this._needsMore = true;
          return null;
        }
        counts.set(parseInt(this.defaultVariantId, 10), 1);
        this._chosen.slice(0, need).forEach((c) => {
          const id = parseInt(c.id, 10);
          counts.set(id, (counts.get(id) || 0) + 1);
        });
      } else {
        counts.set(parseInt(this.defaultVariantId, 10), qty);
      }

      // Angehakte PDP-Upsells ("Mach dein Geschenk komplett") mitnehmen —
      // sie hängen als Checkboxen am selben Produktformular (form-Attribut).
      document
        .querySelectorAll('input[type="checkbox"][form="product-form-' + this.sectionId + '"]:checked')
        .forEach((cb) => {
          const id = parseInt(cb.value, 10);
          if (id) counts.set(id, (counts.get(id) || 0) + 1);
        });

      return Array.from(counts, ([id, quantity]) => ({ id, quantity }));
    }

    closeModal() {
      if (this._modal) this._modal.hidden = true;
      document.body.style.overflow = '';
    }

    getCartElement() {
      // Drawer bevorzugen: das Theme nutzt cart_type "drawer"; cart-notification
      // kann trotzdem im DOM stehen und würde sonst den falschen Pfad rendern.
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }

    async addToCart(form) {
      if (this._busy) return;
      this._busy = true;
      this._needsMore = false;
      const items = this.collectItems();
      if (!items || items.length === 0) {
        this._busy = false;
        if (this._needsMore) this.openModal(this.slotsNeeded() - this._chosen.length);
        return;
      }

      const submitButton = form.querySelector('[type="submit"]');
      if (submitButton) {
        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.classList.add('loading');
        const spinner = submitButton.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');
      }

      const cart = this.getCartElement();
      const body = { items };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
      }

      try {
        const response = await fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify(body),
        });
        const data = await response.json();

        if (!response.ok || data.status) {
          alert(data.description || data.message || 'Der Artikel konnte nicht hinzugefügt werden.');
          return;
        }

        if (cart && typeof cart.renderContents === 'function') {
          if (data.items && data.items.length) Object.assign(data, data.items[0]);
          // War der Warenkorb leer, trägt der Drawer noch "is-empty" und sucht
          // beim Öffnen einen Leer-Container, den es nach dem Rendern nicht
          // mehr gibt (trapFocus-Fehler). Klasse vor dem Öffnen entfernen.
          cart.classList.remove('is-empty');
          cart.renderContents(data);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cc-bundle-offer', cartData: data });
          }
        } else {
          window.location.href = '/cart';
        }
      } catch (e) {
        window.location.href = '/cart';
      } finally {
        this._busy = false;
        if (submitButton) {
          submitButton.removeAttribute('aria-disabled');
          submitButton.classList.remove('loading');
          const spinner = submitButton.querySelector('.loading__spinner');
          if (spinner) spinner.classList.add('hidden');
        }
      }
    }

    // Countdown bis Mitternacht (lokale Zeit des Besuchers).
    initCountdown() {
      const el = this.querySelector('[data-cc-countdown]');
      if (!el) return;
      const showSeconds = el.dataset.showSeconds === 'true';
      const tick = () => {
        const now = new Date();
        const end = new Date(now);
        end.setHours(24, 0, 0, 0);
        let s = Math.max(0, Math.floor((end - now) / 1000));
        const h = String(Math.floor(s / 3600)).padStart(2, '0');
        const m = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
        const sec = String(s % 60).padStart(2, '0');
        el.textContent = showSeconds ? h + ':' + m + ':' + sec : h + ':' + m;
      };
      tick();
      this._timer = setInterval(tick, showSeconds ? 1000 : 10000);
    }
  }
  customElements.define('cc-bundle-offer', CcBundleOffer);
}
